import { cn } from '@/lib/utils';

interface LegendProps {
  /** Each item's swatch is a background class, e.g. "bg-indigo-700". */
  items: Array<{ label: string; swatch: string }>;
  className?: string;
}

export function Legend({ items, className }: LegendProps) {
  return (
    <ul className={cn('flex gap-5 text-xs font-medium leading-4 text-gray-900', className)}>
      {items.map(({ label, swatch }) => (
        <li key={label} className='flex items-center gap-1.5 whitespace-nowrap'><span className={cn('size-3 rounded-full', swatch)} />{label}</li>
      ))}
    </ul>
  );
}
